import React from 'react';
import { Label, Button } from 'reactstrap';
import LaboralBulkLoadHiringTable from './table';
import swal from "sweetalert2";
import _ from 'lodash-es';

const LaboralBulkLoadHiringTableErrors = ({
  hiringBulkErrors,
  setHiringBulkErrors,
  isExistHiringId,
  handleValidateHiringId,
  iconNewHiring,
  customFieldsHeaders,
  employeesSelect,
  costCenterSelect,
  currentUser
}) => {

  const onChangeCellValues = (value, row, key) => {
    const updatedErrors = hiringBulkErrors.map(item => {
      if (item.row === row.row) {
        return { ...item, [key]: value };
      }
      return item;
    });
    setHiringBulkErrors(updatedErrors);
  }

  const renderActions = (rowData) => {
    return (
      <div className="d-flex align-items-center justify-content-center gap-1">
        <Button
          onClick={() => handleValidateHiringId(rowData)}
          color="success"
          outline
          className="border-0"
        >
          <i className="fa fa-redo-alt" />
        </Button>

        <Button
          icon=" fas fa-trash-alt"
          color="danger"
          outline
          onClick={() => handleDestroyHiringError(rowData.row)}
          className="border-0"
        >
          <i className="fas fa-trash-alt" />
        </Button>

        {iconNewHiring(rowData)}
      </div>
    );
  }

  const handleDestroyHiringError = (row, direct = false) => {
    if (!direct) {
      swal.fire({
        title: 'Eliminar fila',
        text: "¿Estás seguro de eliminar la fila?",
        icon: 'warning',
        showCancelButton: true,
        customClass: {
          confirmButton: 'swal2-confirm btn btn-success ml-3',
          cancelButton: 'swal2-cancel btn btn-secondary'
        },
        buttonsStyling: false,
        confirmButtonText: "<i class='fa fa-thumbs-up'></i> Confirmar",
        cancelButtonText: "<i class='fa fa-thumbs-down'></i> Cancelar",
        reverseButtons: true
      }).then((result) => {
        if (result.isConfirmed) {
          const _hiringBulkErrors = hiringBulkErrors.filter(item => item.row !== row);
          setHiringBulkErrors(_hiringBulkErrors);
          swal.fire(
            'Eliminado!',
            'La fila ha sido eliminada correctamente',
            'success'
          );
        }
      });
    } else {
      const _hiringBulkErrors = hiringBulkErrors.filter(item => item.row !== row);
      setHiringBulkErrors(_hiringBulkErrors);
    }
  };

  const drawHiringBulkErrors = () => {
    if (hiringBulkErrors && hiringBulkErrors.length > 0) {
      return (
        <LaboralBulkLoadHiringTable
          data={hiringBulkErrors}
          dataKey="row"
          employeesSelect={employeesSelect}
          costCenterSelect={costCenterSelect}
          customFieldsHeaders={customFieldsHeaders}
          currentUser={currentUser}
          actionsRenderer={renderActions}
          onDataChange={onChangeCellValues}
          title={<Label className="text-danger mb-2 fw-bold">Registros con Errores ({hiringBulkErrors.length}):</Label>}
          showErrors={true}
          isExistHiringId={isExistHiringId}
        />
      );
    }
  };

  return (
    <div className="row">
      <div className="col-12">
        {drawHiringBulkErrors()}
      </div>
    </div>
  );
};

export default LaboralBulkLoadHiringTableErrors;
